{
  "personalizedDestinations": {
    "title": "Kohteita, joista voisit pitää"
  },
  "viewDetails": "Katso tiedot",
  "moneyBackHighlight": {
    "title": "Täysi hyvitys, jos peruutat 24 tunnissa",
    "description": "Helppo online -peruutus. Ei maksuja."
  },
  "modal": {
    "moneyBackHighlightTitle": "24 tunnin peruutussääntö"
  }
}
